import { StateNode } from "../../StateNode.mjs";
class EditingShape extends StateNode {
  static id = "editing_shape";
  onPointerEnter = (info) => {
    switch (info.target) {
      case "shape": {
        const { selectedIds, focusLayerId } = this.editor;
        const hoveringShape = this.editor.getOutermostSelectableShape(
          info.shape,
          (parent) => !selectedIds.includes(parent.id)
        );
        if (hoveringShape.id !== focusLayerId) {
          this.editor.setHoveredId(hoveringShape.id);
        }
        break;
      }
    }
  };
  onPointerLeave = (info) => {
    switch (info.target) {
      case "shape": {
        this.editor.setHoveredId(null);
        break;
      }
    }
  };
  onExit = () => {
    if (!this.editor.pageState.editingId)
      return;
    const { editingId } = this.editor.pageState;
    if (!editingId)
      return;
    this.editor.setEditingId(null);
    const shape = this.editor.getShapeById(editingId);
    const util = this.editor.getShapeUtil(shape);
    util.onEditEnd?.(shape);
  };
  onPointerDown = (info) => {
    switch (info.target) {
      case "shape": {
        const { shape } = info;
        const { editingId } = this.editor.pageState;
        if (editingId) {
          if (shape.id === editingId) {
            return;
          }
          const editingShape = this.editor.getShapeById(editingId);
          if (editingShape) {
            const editingShapeUtil = this.editor.getShapeUtil(editingShape);
            editingShapeUtil.onEditEnd?.(editingShape);
            const util = this.editor.getShapeUtil(shape);
            if (shape.type === editingShape.type && util.canEdit?.(shape) && !this.editor.isShapeOrAncestorLocked(shape)) {
              this.editor.setEditingId(shape.id);
              this.editor.setHoveredId(shape.id);
              this.editor.setSelectedIds([shape.id]);
              return;
            }
          }
        }
      }
    }
    this.parent.transition("idle", info);
    this.parent.current.value?.onPointerDown?.(info);
  };
  onComplete = (info) => {
    this.parent.transition("idle", info);
  };
  onCancel = (info) => {
    this.parent.transition("idle", info);
  };
}
export {
  EditingShape
};
//# sourceMappingURL=EditingShape.mjs.map
